import { CommonModule } from '@angular/common';
import { Component, Inject, NgModule, OnInit } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { TestService } from '@services/test.service';
import { WebErrorService } from '@services/webError.service';

@Component({
  selector: 'app-instruction-dialog-readonly',
  templateUrl: './instruction-dialog-readonly.component.html',
  styleUrls: ['./instruction-dialog-readonly.component.scss']
})
export class InstructionDialogReadonlyComponent implements OnInit {
  testuuId: any;
  instruction: string;

  constructor(public dialogRef: MatDialogRef<InstructionDialogReadonlyComponent>,
    @Inject(MAT_DIALOG_DATA) public data, private testService: TestService, private webErrorService: WebErrorService,) {
  }

  ngOnInit() {
    this.testService.getInstruction(this.data.instructionid)?.subscribe(
      (result) => {
        const instructionDescription = JSON.parse(result.data.instructiondescription);
        this.instruction = instructionDescription['description'];
      },
      (error: any) => {
        this.webErrorService.handleAPIErrors(error);
      });
  }

  onClose() {
    this.dialogRef.close();
  }
}

@NgModule({
  declarations: [InstructionDialogReadonlyComponent],
  imports: [CommonModule,
    MatButtonModule,
    MatDialogModule,
    MatIconModule,
    MatDividerModule,
    ReactiveFormsModule]
})
class InstructionDialogReadonlyComponentModule { }
